export default __webpack_public_path__ + "static/media/service-2.3ac53c09.jpg";